import React, { useEffect, useState } from 'react';
import Navbar from "../components/navbar";
import Footer from '../components/Footer';
import './GuestLecture.css';
import CTAButtons from '../components/sticky-button';
import { Helmet } from 'react-helmet-async';
import BrochureForm from '../components/brochure-form';
import PageHeader from '../about/PageHeader';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const GuestSession = () => {
  const [data, setData] = useState({});
  const [selectedYear, setSelectedYear] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);

  // ✅ Fetch data from public API on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Use public API - no JWT required
        const response = await fetch(`${API_URL}/guest-session`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const result = await response.json();
        console.log('Guest sessions data received:', result);
        
        // ✅ Data is already grouped by academic_year from backend
        setData(result);
        
        // Set latest year as default
        const years = Object.keys(result).sort((a, b) => 
          b.localeCompare(a, undefined, { numeric: true })
        );
        
        if (years.length > 0) {
          setSelectedYear(years[0]);
        }
        
        setError(null);
      } catch (error) {
        console.error('Error fetching guest sessions:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const years = Object.keys(data).sort((a, b) => 
    b.localeCompare(a, undefined, { numeric: true })
  );

  const sessionsForYear = data[selectedYear] || [];

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="guest-session-container">
          <h2 style={{ textAlign: 'center', padding: '40px' }}>Loading Guest Sessions...</h2>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <div className="guest-session-container">
          <h2 style={{ textAlign: 'center', padding: '40px', color: '#d32f2f' }}>
            Error: {error}
          </h2>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Guest Lecture Sessions | TIMSCDR</title>
        <meta name="description" content="Explore guest lecture sessions from industry experts at TIMSCDR. Learn from leaders and innovators." />
        <meta name="keywords" content="guest lectures, industry experts, TIMSCDR, seminars" />
      </Helmet>

      <Navbar />

      <div className="alumni-container">
        {/* Header Section */}
        <div className="alumni-header">
          <PageHeader 
                     title="Guest Lecture"
                     crumbs={[
                       { label: 'Home', href: '/Guest Lecture' },
         
                       { label: 'FDP', href: '/Guest Lecture' }
                     ]}
                   />
          <p>
            Our Guest Sessions invite industry leaders and experts to share insights, experiences, 
            and knowledge with our students, enriching their learning journey. Explore the sessions 
            held across different academic years below:
          </p>
        </div>

        {/* Year Buttons */}
        {years.length > 0 && (
          <div className="alumni-buttons-container">
            {years.map((year) => (
              <button
                key={year}
                className={selectedYear === year ? 'year-button active' : 'year-button'}
                onClick={() => setSelectedYear(year)}
                title={year}
              >
                {year}
              </button>
            ))}
          </div>
        )}

        {/* Sessions Cards */}
        {sessionsForYear.length > 0 ? (
          <div className="guest-cards-container">
            <div className="guest-cards-grid">
              {sessionsForYear.map(session => (
                <div key={session.id} className="guest-card">
                  <div className="guest-card-header">
                    <div className="guest-card-icon">🎤</div>
                    <div className="guest-card-date">
                      {new Date(session.date).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </div>
                  </div>
                  <div className="guest-card-body">
                    <span className="guest-card-label">Guest Session</span>
                    <h3>{session.name}</h3>
                    <p className="guest-card-designation">{session.designation}</p>
                    <p className="guest-card-topic">{session.topic}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="no-data">
            <p>No guest sessions found for {selectedYear}. Check back later!</p>
          </div>
        )}

        {years.length === 0 && (
          <div className="no-data">
            <p>No guest sessions available yet. Stay tuned!</p>
          </div>
        )}
      </div>

      {/* CTA and Form */}
      <CTAButtons />
      {showForm && <BrochureForm onClose={() => setShowForm(false)} />}

      <Footer />
    </>
  );
};

export default GuestSession;